const Glide = require('@glidejs/glide')
const axios = require('axios')
const { list } = require('postcss')
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

import Swiper, { Navigation, Autoplay } from 'swiper'

Swiper.use([Navigation, Autoplay])

window.addEventListener('DOMContentLoaded', function (e) {
	function GlideAutoHeight(Glide, Components, Events) {
		const Component = {
			mount() {
				if (!Glide.settings.autoHeight) return
				Components.Html.track.style.transition = 'height 200ms ease-in-out'
				this.updateTrackHeight()
			},

			updateTrackHeight() {
				if (!Glide.settings.autoHeight) return

				const activeSlides = Components.Html.slides.filter((slide, index) => {
					return index >= Glide.index && index <= Glide.index - 1 + Glide.settings.perView
				})

				const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
					return Math.max(maxHeight, slide.offsetHeight)
				}, 0)

				const glideTrack = Components.Html.track
				if (newMaxHeight !== glideTrack.offsetHeight) glideTrack.style.height = `${newMaxHeight}px`
			},
		}

		Events.on('run', () => {
			Component.updateTrackHeight()
		})
		Events.on('update', () => {
			Component.updateTrackHeight()
		})
		Events.on('resize', () => {
			Component.updateTrackHeight()
		})

		return Component
	}

	new Glide.default('#glideHighlightArticles', {
		type: 'carousel',
		startAt: 0,
		perView: 1,
		autoplay: 5000,
		animationDuration: 1000,
		animationTimingFunc: 'ease-in-out',
		autoHeight: true,
	}).mount({
		GlideAutoHeight,
	})

	// new Glide.default('#glideMultimedia', {
	// 	type: 'carousel',
	// 	startAt: 0,
	// 	perView: 3,
	// 	gap: 192,
	// 	autoplay: 5000,
	// 	focusAt: 'center',
	// 	animationDuration: 150,
	// 	autoHeight: true,
	// 	breakpoints: {
	// 		1365: {
	// 			gap: 105,
	// 		},
	// 	},
	// }).mount()

	let multi_swiper = new Swiper('.multi', {
		autoplay: {
			delay: 5000,
		},
		speed: 1000,
		slidesPerView: 3,
		spaceBetween: 160,
		slidesPerGroup: 1,
		loop: true,
		autoHeight: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	})
	let multi_elem = document.querySelector('.multi')
	let swiper_next_elem = multi_elem.querySelector('.swiper-slide-next article')
	Object.assign(multi_elem.style, {
		height: `${swiper_next_elem.clientHeight * 1.75}px`,
	})
	// window.addEventListener('resize', function () {
	// 	let swiper_next_elem = multi_elem.querySelector('.swiper-slide-next article')
	// 	Object.assign(multi_elem.style, {
	// 		height: `${swiper_next_elem.clientHeight * 1.75}px`,
	// 	})
	// })
	multi_swiper.on('slideChangeTransitionEnd', function () {
		let swiper_next_elem = multi_elem.querySelector('.swiper-slide-next article')
		console.log(7, swiper_next_elem.clientHeight * 1.75)
		Object.assign(multi_elem.style, {
			height: `${swiper_next_elem.clientHeight * 1.75}px`,
		})
	})

	let boxLocation = document.querySelector('.box-location')
	let selectListLocation, listLocation, locationName, viewMore, linkListLocation
	if (boxLocation) {
		selectListLocation = boxLocation.querySelector('.select-list-location')
		listLocation = boxLocation.querySelector('.list-location')
		locationName = boxLocation.querySelector('.location-name')
		viewMore = boxLocation.querySelector('.view-more')

		if (listLocation) {
			linkListLocation = listLocation.querySelectorAll('a')
		}
	}
	let locationArticles = document.querySelector('.location-articles')

	// selectListLocation.addEventListener('click', function (e) {
	// 	listLocation.classList.toggle('hidden')
	// })

	document.addEventListener('click', function (e) {
		if (selectListLocation.contains(e.target)) {
			listLocation.classList.toggle('hidden')
		} else {
			if (!listLocation.classList.contains('hidden')) {
				listLocation.classList.add('hidden')
			}
		}
	})
	let urlOfFirstElem = '/events/eb2wt7nVR.html'
	axios(urlOfFirstElem, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			fetch: 'location',
		},
	})
		.then((data) => {
			locationArticles.innerHTML = data.data
		})
		.catch((err) => {
			console.log(err)
		})

	linkListLocation.forEach((elem) => {
		elem.addEventListener('click', function (e) {
			e.preventDefault()
			locationName.textContent = elem.textContent
			viewMore.href = elem.href
			let url = elem.href
			axios(url, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					fetch: 'location',
				},
			})
				.then((data) => {
					locationArticles.innerHTML = data.data
				})
				.catch((err) => {
					console.log(err)
				})
		})
	})

	// we need to set this here for now.
	// var marquee_vert
	// var marquee_hort

	// // first, let's grab the element we're going to move around
	var marquee_vertical = document.querySelector('#marquee-vertical')
	if (marquee_vertical) {
		let splideVert = new Splide('#marquee-vertical', {
			type: 'loop',
			direction: 'ttb',
			height: '100vh',
			fixedWidth: '300px',
			autoHeight: true,
			drag: 'free',
			autoScroll: {
				speed: 1,
			},
			arrows: false,
			pagination: false,
		})

		splideVert.mount({ AutoScroll })
	}

	// var marquee_vertical_children = marquee_vertical.querySelectorAll( '.cell')

	// // first, let's grab the element we're going to move around
	var marquee_horizontal = document.querySelector('#marquee-horizontal')
	if (marquee_horizontal) {
		let splideHori = new Splide('#marquee-horizontal', {
			type: 'loop',
			drag: 'free',
			focus: 'center',
			height: '9rem',
			perPage: 3,
			autoWidth: true,
			autoScroll: {
				speed: 1,
			},
			arrows: false,
			pagination: false,
		})

		splideHori.mount({ AutoScroll })
	}
	// var marquee_horizontal_children = marquee_horizontal.querySelectorAll( '.cell')

	// // the key here is not to animate all of the cells in the grid, which might be products or what have you; we have a grid constrained by a container, so we can just translate the entire grid and only the part of the grid that fits into the container will be visible anyway
	// function createMarquee(marquee, parent, children, vertical = true){

	// 	// just to be doubly sure there's an animation method...
	// 	if ('animate' in parent && typeof parent.animate === 'function') {

	// 		// we're going to recreate the marquee animation when the viewport is resized
	// 		// so get rid of any existing animation first
	// 		if( typeof marquee !== 'undefined' ) marquee.cancel()

	// 		// now for the playing/pausing
	// 		parent.addEventListener('mouseenter', () => {
	// 			if( marquee.playState === 'running' ) marquee.pause()
	// 		}, false)
	// 		parent.addEventListener('mouseleave', () => {
	// 			if( marquee.playState === 'paused' ) marquee.play()
	// 		}, false)

	// 		// set this dynamically, so the thing will gracefully degrade to a typical grid of items
	// 		parent.style.whiteSpace = 'nowrap'

	// 		// create a variable for the distance by which the grid element will be transformed
	// 		var displacement = 0

	// 		// the width of all the elements in the marquee
	// 		// it's important to tot up the child element widths because if overflow is hidden,
	// 		// the clientWidth of the grid_to_animate element will be that of the parent element
	// 		for ( var j = 0; j < children.length; ++j ) displacement += vertical ? children[j].clientHeight : children[j].clientWidth

	// 		// crucial: subtract the width of the container
	// 		// take the opportunity to round the displacement value down to the nearest pixel
	// 		// the browser may thank you for this by not blurring the shit out of your text
	// 		// displacement = (displacement - vertical ? parent.clientHeight : parent.clientWidth) << 0

	// 		let destinationTransform = vertical ? { transform: `matrix(1, 0.00, 0.00, 1, 0, ${-displacement})`, offset: 1 } : { transform: `matrix(1, 0.00, 0.00, 1, ${-displacement}, 0)`, offset: 1 }
	// 		// by using the variable 'marquee' we created in the parent scope,
	// 		// we can easily use the reference to pause/cancel the animation later if necessary
	// 		marquee = parent.animate([
	// 		// these are your keyframes, if you are familiar with the CSS syntax
	// 		// so your 'from' or '0%' keyframe translates to 'offset: 0'
	// 		// 'to'/'100%' translates to 'offset: 1'
	// 		// and anything in betwen like '54%' will be 'offset: .54'
	// 			{ transform: 'matrix(1, 0.00, 0.00, 1, 0, 0)', offset: 0 },
	// 			destinationTransform
	// 		// you don't have to use matrix, I just like it
	// 		],
	// 		{
	// 		// animation-duration = 1 second for each element in marquee
	// 		// arbitrary decision
	// 			duration: children.length * 2e3,

	// 			// could be 'ease', 'cubic-bezier(.4,0,.2,1)', etc.
	// 			easing: 'linear',

	// 			// useful if you don't want the animation to start until your content has loaded from, say, a REST API and you want to speculate a reasonable time for that to take
	// 			delay: 0,

	// 			// kind of crucial for a marquee...
	// 			iterations: Infinity,

	// 			// invert animation after completion, so it scrolls backwards */
	// 			direction: 'normal',

	// 			// you would use this if your animation is set to occur only a finite number of times, and you wanted the animated element to finish at the end keyframe, rather than the first keyframe
	// 			fill: 'forwards'
	// 		})
	// 	}
	// }

	// // quick check for the WAAPI method
	// // you could also do if (typeof grid_to_animate.animate !== 'undefined')
	// // but this is cleaner in my opinion
	// if (marquee_vertical && marquee_vertical_children && 'animate' in marquee_vertical && typeof marquee_vertical.animate === 'function') {

	// 	// okay, let's fire up the marquee!
	// 	createMarquee(marquee_vert, marquee_vertical, marquee_vertical_children, true)

	// }
	// if (marquee_horizontal && marquee_horizontal_children && 'animate' in marquee_horizontal && typeof marquee_horizontal.animate === 'function') {

	// 	// okay, let's fire up the marquee!
	// 	createMarquee(marquee_hort, marquee_horizontal, marquee_horizontal_children, false)

	// }
})
